var map = {
	"./2020Vision_abyssWithinMe_55.avif": 13193,
	"./2020Vision_canYouSeeMe_55.avif": 1908,
	"./2020Vision_undertheMidnightSun_55.avif": 70865,
	"./2020Vision_wordandaRing_55.avif": 16882,
	"./ainaWassvik_dauntless_55.avif": 40398,
	"./ainaWassvik_hypnotized_55.avif": 5625,
	"./audunHaukvik_drivingAlone_55.avif": 82746,
	"./benjaminDehli_cantiquedeNoel_55.avif": 36971,
	"./benjaminDehli_cantiquedeNoelinstrumental_55.avif": 24503,
	"./benjaminDehli_lauraPalmersThemeCover_55.avif": 153,
	"./benjaminDehli_rachelsSongCover_55.avif": 71078,
	"./benjaminDehli_twinPeaksThemeCover_55.avif": 9882,
	"./bjoernEidsvaagYlva_skyfriHimmel_55.avif": 78194,
	"./changemakers_veidemannen_55.avif": 5071,
	"./confusion_confusion_55.avif": 6710,
	"./confusion_escapeExplore_55.avif": 65668,
	"./confusion_fadeAway_55.avif": 25396,
	"./confusion_itsAllTooClear_55.avif": 32826,
	"./confusion_lettheGamesBegin_55.avif": 89424,
	"./confusion_thisTime_55.avif": 71295,
	"./esbenMeyer_taakemann_55.avif": 42345,
	"./grisene_julIgjen_55.avif": 75409,
	"./haaker_brothers_55.avif": 61529,
	"./haaker_guardianAngels_55.avif": 61471,
	"./haaker_rocknrolla_55.avif": 62883,
	"./hanneStaver_theWords_55.avif": 75309,
	"./hauntedBySilhouettesBjornSpeedStrid_selkie_55.avif": 79118,
	"./hauntedBySilhouettes_deadlock_55.avif": 7908,
	"./hauntedBySilhouettes_departure_55.avif": 23483,
	"./hauntedBySilhouettes_flock_55.avif": 4592,
	"./hauntedBySilhouettes_icon_55.avif": 66900,
	"./hauntedBySilhouettes_noManIsle_55.avif": 17,
	"./hauntedBySilhouettes_theLastDayonEarth_55.avif": 86129,
	"./hauntedBySilhouettes_undertow_55.avif": 639,
	"./kAASIN_carryOn_55.avif": 6741,
	"./kAASIN_chainofLove_55.avif": 53911,
	"./kAASIN_deadMansHand_55.avif": 90529,
	"./kAASIN_hidden_55.avif": 38391,
	"./kAASIN_insideOut_55.avif": 76735,
	"./kAASIN_revelation_55.avif": 42300,
	"./kAASIN_runawayTrain_55.avif": 71574,
	"./kAASIN_shadesofYesterday_55.avif": 91548,
	"./kAASIN_theSmokingGun_55.avif": 86826,
	"./kAASIN_walkingDownwards_55.avif": 33257,
	"./kAASIN_weAreOne_55.avif": 72085,
	"./kAASIN_wrong_55.avif": 560,
	"./leneNevisdal_giveMeaSmileJoe_55.avif": 81602,
	"./setOnesCap_dontYouWannaKnow_55.avif": 62465,
	"./setOnesCap_likeaStone_55.avif": 58694,
	"./setOnesCap_waitfortheOther_55.avif": 87122,
	"./southofJameson_findmyshelterBonusTrackDemo_55.avif": 22880,
	"./southofJameson_littlegirlBonusTrackDemo_55.avif": 50835,
	"./southofJameson_womaninmydreamsBonusTrackDemo_55.avif": 14515,
	"./spinningWheelsBandRandleCurrieJustinWilliamson_backWhen_55.avif": 32188,
	"./spinningWheelsBand_powerofaGrin_55.avif": 77794,
	"./staaleKaasin_totheTop_55.avif": 1500,
	"./taxiBear_koreaTown_55.avif": 37978,
	"./theWhiteDevil_getLucky_55.avif": 60214,
	"./thomasTveiten_daaEDetVerdtDet_55.avif": 27843,
	"./wildWhens_backtrackJack_55.avif": 29638,
	"./wildWhens_chainsofYesterday_55.avif": 3322,
	"./wildWhens_crazytotheBoneRemastered_55.avif": 58360,
	"./wildWhens_crazytotheBone_55.avif": 38082,
	"./wildWhens_fromtheValley_55.avif": 8453,
	"./wildWhens_rebelHeart_55.avif": 19061,
	"./wildWhens_sailinSarah_55.avif": 43766,
	"./wildWhens_travellinMan_55.avif": 82654,
	"./wolfMoonFever_diggingintoMyPast_55.avif": 23984,
	"./wolfMoonFever_seaofGreen_55.avif": 52838,
	"./wolfMoonFever_theKeeperoftheLighthouse_55.avif": 84248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29497;